import styled from 'styled-components';

// eslint-disable-next-line rulesdir/no-styled-export
export const UserAvatarContainer = styled.span`
    border-radius: 50%;
    display: flex;
    overflow: visible;
    position: relative;
`;
